import { render, staticRenderFns } from "./OtaApp.vue?vue&type=template&id=5883e786&"
import script from "./OtaApp.vue?vue&type=script&lang=js&"
export * from "./OtaApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports